import React from 'react';
import { Grid, Typography, Button, Icon, Chip, FormHelperText } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { ClientContext } from '../../ClientContext';
import { TableEmpty } from '../../../../shared/components/TableEmpty';
import { VehicleModel } from '../../../../Models/VehicleModel';
import { EditAction } from '../../../../shared/enum/EditAction';
import { ClientErrorContext } from '../../ClientErrorContext';
import { ClientVehicleModal } from '../components/ClientVehicleModal';
import { FilterChipsSearchField } from '../../../../shared/components/FilterChipsSearchField';
import VehicleClientService from '../../../../Services/VehicleClientService';

const useStyles = makeStyles(() => createStyles({
    textButton: {
        paddingLeft: 0,
        '&:hover': {
            textDecorationLine: 'underline',
        },
    },
    vehicleChipList: {
        overflow: 'auto',
        overflowX: 'hidden',
        maxHeight: '240px'
    },
}));

export function ClientVehicle() {
    const classes = useStyles();

    const clientContext = React.useContext(ClientContext);
    const clientErrorContext = React.useContext(ClientErrorContext);

    const [searchVehicle, setSearchVehicle] = React.useState<string>('');

    const [showAddVehicleDialog, setShowAddVehicleDialog] = React.useState<boolean>(false);

    const handleDeleteVehicle = (vehicle: VehicleModel) => {
        const listVehicleSelect = (clientContext.vehicles)
            ? [...clientContext.vehicles]
            : [];

        const index = listVehicleSelect.findIndex(k => k.id == vehicle.id);

        if (listVehicleSelect[index].editAction == EditAction.INSERT)
            listVehicleSelect.splice(index, 1);
        else
            listVehicleSelect[index].editAction = EditAction.DELETE;

        clientContext.setVehicles(listVehicleSelect);
    };

    const handleDownload = async () => {
        try {
            const response = await VehicleClientService.vehicleClientServiceDownload(clientContext.client.id);
            if (!response || !response.data) {
                throw new Error('Resposta inválida do servidor.');
            }

            const blob = new Blob([response.data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');

            a.href = url;
            a.download = `veiculos_${clientContext.client.name}.xlsx`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);

            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Erro ao baixar o arquivo:', error);
        }
    };

    const getAddNewButton = () => {
        return (
            <Button
                onClick={() => setShowAddVehicleDialog(true)}
                className={classes.textButton}
                startIcon={<Icon color='primary'>add</Icon>}>
                Adicionar Veículo
            </Button>
        );
    };

    const getDownloadFile = () => {
        return (
            <Button
                onClick={handleDownload}
                size="large"
                color="primary"
                variant="outlined"
            >
                Exportar Veículos
            </Button>
        );
    };

    const getVehicleList = () => {
        const listFilter = searchVehicle !== ''
            ? clientContext.vehicles.filter(vehicle =>
                vehicle.nomenclature?.toLowerCase().includes(searchVehicle.toLowerCase()) && vehicle.editAction != EditAction.DELETE)
            : clientContext.vehicles.filter(vehicle => vehicle.editAction != EditAction.DELETE);

        return (
            <Grid container spacing={2} className={classes.vehicleChipList}>
                {listFilter && listFilter.map((vehicle) => {
                    return <Grid item key={vehicle.id}>
                        <Chip
                            key={vehicle.id}
                            label={vehicle.nomenclature}
                            deleteIcon={<Icon>close</Icon>}
                            onDelete={() => { handleDeleteVehicle(vehicle); }}
                            color='primary' />
                    </Grid>;
                })}
            </Grid>
        );
    };

    const getDisplayVehicleChipList = () => {
        const activeVehicles = clientContext.vehicles.filter(v => v.editAction != EditAction.DELETE);

        if (activeVehicles.length > 0) {
            return (
                <Grid container direction="column" spacing={3}>
                    <Grid item xs={12} sm={6}>
                        <FilterChipsSearchField
                            key="client-vehicle-search-field"
                            searchText={searchVehicle}
                            setSearchText={setSearchVehicle} />
                    </Grid>

                    <Grid item xs={12} sm={12}>
                        {getVehicleList()}
                    </Grid>

                </Grid>

            );
        }
        else {
            const error = clientErrorContext.vehicleNotDefinedError && !(clientContext.vehicles && clientContext.vehicles.length > 0);

            return (
                <>
                    <TableEmpty
                        displayText='Nenhum veículo cadastrado'
                        cssProperties={{
                            minHeight: '150px',
                            errorBorder: error
                        }} />
                    {error &&
                        <FormHelperText error>
                            Você precisa inserir pelo menos um veículo para este cliente.
                        </FormHelperText>
                    }
                </>
            );
        }
    };

    return (
        <>
            <Grid
                container
                direction="column"
                spacing={1}>

                <Grid item xs={12}>
                    <Typography variant="subtitle1" >Veículo</Typography>
                </Grid>

                <Grid item xs={12}>
                    <Grid container justifyContent="space-between">

                        <Grid> {getAddNewButton()}</Grid>
                        <Grid>{getDownloadFile()}</Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    {getDisplayVehicleChipList()}
                </Grid>

            </Grid>

            <ClientVehicleModal
                showDialog={showAddVehicleDialog}
                setShowDialog={setShowAddVehicleDialog} />
        </>
    );
}